<template>
  <bita-modal :id="modalId" :title="title" :isLoading="isLoading" @close="onCloseModal">
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input ref="name" type="text" name="name" label="Lat"
                        :validation-container-class="colWidth" input-class="form-control" v-model="form.latitude" />
            <bita-input ref="name" type="text" name="name" label="Long"
                        :validation-container-class="colWidth" input-class="form-control" v-model="form.longitude" />
            <bita-input ref="name" type="text" name="name" label="شعاع"
                        :validation-container-class="colWidth" input-class="form-control" v-model="form.deliver_radius" />
            <bita-input ref="name" type="text" name="name" label="ebl_id"
                        :validation-container-class="colWidth" input-class="form-control" v-model="form.ebl_id" />
          </div>
        </div>
      </bita-form>
      <div slot="footer" class="d-flex justify-content-center">
        <bita-bootbutton type="primary" title="بروزرسانی" icon="fa fa-check" btn-width="150px"
          @click.native="handleSubmit()" />
        <bita-bootbutton class="mr-2" type="danger" title="بستن" icon="fas fa-times" btn-width="150px"
          data-dismiss="modal" @click.native="() => {
            $emit('change-status-modal')
          }" />
      </div>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    propsData: {
      type: Object,
      default: {
        id: 0,
        name: "",
      },
    },
  },
  data() {
    return {
      colWidth: "col-12",
      form: {},
    };
  },
  watch: {
    propsData: function (_data) {
      this.form = _data;
    },
  },
  methods: {
    toggleLoading() {
      this.$emit("isLoading");
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.form);
        }
      });
    },
    onCloseModal() {
      if (this.$refs.name)
        this.$refs.name.emptyKendo();
      this.$refs.form.reset();
    },
  },
};
</script>
